import SuccessIcon from './success';
import WarningIcon from './warning';
import InfoIcon from './info';
import ErrorIcon from './error';
import ServerErrorIcon from './server-error';
import DashboardIcon from './dashboard';
import AuthenticationIcon from './authentication';
import CalendarIcon from './calendar';
import ChartIcon from './chart';
import FormsIcon from './forms';
import InboxIcon from './inbox';
import InventoryIcon from './inventory';
import InvoiceIcon from './invoice';
import MessagesIcon from './messages';
import PagesIcon from './pages';
import ProductsIcon from './products';
import ProfileIcon from './profile';
import PurchaseIcon from './purchase';
import SaleIcon from './sale';
import TablesIcon from './tables';
import TaskIcon from './task';
import UiElementsIcon from './ui-elements';
import UserManagementIcon from './user-management';
import ChevronDownIcon from './ChevronDownIcon';
import FinanceIcon from './finance';
import CashIcon from './cash';
import DefaultIcon from './defaultIcon';
import ContinueIcon from './continue';
import CancelIcon from './cancel';
import PlusIcon from './plus';
import ArrowLeftIcon from './arrowLeftIcon';
import ReturnIcon from './returnIcon';
import DiscountIcon from './discountIcon';
import CloseIcon from './close';
import AddCircleIcon from './addCircleIcon';
import ServiceAddIcon from './serviceAddIcon';
import SaveIcon from './save';
import PriceIncreaseIcon from './priceIncreaseIcon';
import ConfigurationIcon from './configurationIcon';
import SettleProductIcon from './settleProductIcon';
import DocumentIcon from './document';
import EditIcon from './editIcon';
import ViewIcon from './viewIcon';
import ReportIcon from './reportIcon';
import DownloadIcon from './downloadIcon';
import UploadIcon from './uploadIcon';
import HardwareIcon from './hardwareIcon';
import DeleteIcon from './deleteIcon';
import ShoppingCartIcon from './shoppingCartIcon';
import RotateCcwIcon from './totateCcwIcon';
import PackageCheckIcon from './packageCheckIcon';
import PercentIcon from './percentIcon';
import PdfFileIcon from './pdfFileIcon';
import SearchIcon from './searchIcon';
import JsonIcon from './json';
import InvalidDteIcon from './invalidDteIcon';
import ArrowUpTrendIcon from './arrowUpTrend';
import ArrowDownTrendIcon from './arrowDownTrend';
import UserPlusIcon from './userPlusIcon';
import ShoppingBagIcon from './shoppingBagIcon';
import ClockIcon from './clockIcon';
import XCircleIcon from './xCircleIcon';
import CheckCircleIcon from './checkCircleIcon';
import ExternalServicesIcon from './externalServicesIcon';
import HaciendaIcon from './haciendaIcon';
import EmailIcon from './EmailIcon';
import PrintIcon from './print';
import FinalizeIcon from './finalize';
import FinishFlagIcon from './finishFlag';
import ReceiptCheckIcon from './receiptCheck';
import CategoryIcon from './categoryIcon';
import CatalogIcon from './catalogIcon';
import ChangeIcon from './change';
import HomeIcon from './homeIcon';
import ArrowRightIcon from './arrowRightIcon';
import LockIcon from './lockIcon';
import BrushIcon from './brushIcon';
import SunIcon from './sunIcon';
import MoonIcon from './moonIcon';
import NotificationIcon from './notificationIcon';
import MessageIcon from './messageIcon';
import UserIcon from './userIcon';
import ContactsIcon from './contactsIcon';
import SettingsIcon from './settingsIcon';
import LogoutIcon from './logoutIcon';
import InfoCircleIcon from './infoCircleIcon';
import InfoSquareIcon from './infoSquareIcon';
import BoxIcon from './boxIcon';
import PrinterIcon from './printerIcon';
import TestIcon from './testIcon';
import IllustrationIcon from './illustrationIcon';
import DashboardPreviewIcon from './dashboardPreviewIcon';
import BackgroundBubblesIcon from './backgroundBubblesIcon';
import DotGridIcon from './dotGridIcon';
import LockFilledIcon from './lockFilledIcon';
import DollarIcon from './dollarIcon';
import ChevronUpMiniIcon from './chevronUpMiniIcon';
import ChevronDownMiniIcon from './chevronDownMiniIcon';
import RefreshIcon from './refresh';
import StoreIcon from './storeIcon';
import GiftIcon from './giftIcon';
import TagIcon from './tagIcon';
import CreditCardIcon from './creditCardIcon';
import WalletIcon from './walletIcon';
import EyeIcon from './eyeIcon';
import ReprintIcon from './reprint';
import UndoIcon from './undoIcon';
import RejectIcon from './rejectIcon';
import CheckIcon from './checkIcon';
import GlobeIcon from './globeIcon';
import PayIcon from './payIcon';
import HistoryIcon from './historyIcon';
import FileIcon from './fileIcon';
import CollapseSidebarIcon from './collapseSidebarIcon';
import ExpandSidebarIcon from './expandSidebarIcon';
import PanelLeftCloseIcon from './panelLeftCloseIcon';
import PanelLeftOpenIcon from './panelLeftOpenIcon';
import ProcessIcon from './processIcon';
import RadioIcon from './radioIcon';
import RestaurantIcon from './restaurantIcon';
import MeetingRoomIcon from './meetingRoomIcon';
import TableRestaurantIcon from './tableRestaurantIcon';
import EventSeatIcon from './eventSeatIcon';
import ReceiptLongIcon from './receiptLongIcon';
import SoupKitchenIcon from './soupKitchenIcon';
import RestaurantMenuIcon from './restaurantMenuIcon';
import MenuBookIcon from './menuBookIcon';
import PrecisionManufacturingIcon from './precisionManufacturingIcon';
import Inventory2Icon from './Inventory2Icon';
import ShoppingCart2Icon from './ShoppingCartIcon2';
import WarehouseIcon from './warehouseIcon';
import SwapHorizIcon from './swapHorizIcon';
import StraightenIcon from './straightenIcon';
import CountertopsIcon from './countertopsIcon';
import AssessmentIcon from './assessmentIcon';
import CorporateFareIcon from './corporateFareIcon';
import PointOfSaleIcon from './pointOfSaleIcon';
import BusinessIcon from './businessIcon';
import PaymentsIcon from './paymentsIcon';
import DeleteSweepIcon from './deleteSweepIcon';
import AssignmentReturnIcon from './assignmentReturnIcon';

const iconMap: Record<string, JSX.Element> = {
  'chevron-down': ChevronDownIcon,
  success: SuccessIcon,
  warning: WarningIcon,
  info: InfoIcon,
  error: ErrorIcon,
  'server-error': ServerErrorIcon,
  dashboard: DashboardIcon,
  authentication: AuthenticationIcon,
  calendar: CalendarIcon,
  chart: ChartIcon,
  forms: FormsIcon,
  inbox: InboxIcon,
  inventory: InventoryIcon,
  invoice: InvoiceIcon,
  messages: MessagesIcon,
  pages: PagesIcon,
  products: ProductsIcon,
  profile: ProfileIcon,
  purchase: PurchaseIcon,
  sale: SaleIcon,
  settings: SettingsIcon,
  tables: TablesIcon,
  task: TaskIcon,
  'ui-elements': UiElementsIcon,
  'user-management': UserManagementIcon,
  finance: FinanceIcon,
  cash: CashIcon,
  continue: ContinueIcon,
  change: ChangeIcon,
  cancel: CancelIcon,
  plus: PlusIcon,
  arrowleft: ArrowLeftIcon,
  return: ReturnIcon,
  resend: ReturnIcon, // reutilizamos el ícono de retorno para el reenvío
  discount: DiscountIcon,
  close: CloseIcon,
  'addCircle': AddCircleIcon,
  'serviceAdd': ServiceAddIcon,
  save: SaveIcon,
  finalize: FinalizeIcon,
  finishFlag: FinishFlagIcon,
  receiptCheck: ReceiptCheckIcon,
  'priceIncrease': PriceIncreaseIcon,
  configuration: ConfigurationIcon,
  'settle-products': SettleProductIcon,
  document: DocumentIcon,
  edit: EditIcon,
  view: ViewIcon,
  report: ReportIcon,
  download: DownloadIcon,
  upload: UploadIcon,
  hardware: HardwareIcon,
  trash: DeleteIcon,
  shoppingcart: ShoppingCartIcon,
  'rotate-ccw': RotateCcwIcon,
  'package-check': PackageCheckIcon,
  percent: PercentIcon,
  pdf: PdfFileIcon,
  search: SearchIcon,
  json: JsonIcon,
  invalidDte: InvalidDteIcon,
  'arrow-up-trend': ArrowUpTrendIcon,
  'arrow-down-trend': ArrowDownTrendIcon,
  'user-plus': UserPlusIcon,
  'shopping-bag': ShoppingBagIcon,
  clock: ClockIcon,
  'check-circle': CheckCircleIcon,
  'x-circle': XCircleIcon,
  'external-services': ExternalServicesIcon,
  'hacienda': HaciendaIcon,
  email: EmailIcon,
  print: PrintIcon,
  category: CategoryIcon,
  catalog: CatalogIcon,
  home: HomeIcon,
  'arrow-right': ArrowRightIcon,
  lock: LockIcon,
  brush: BrushIcon,
  sun: SunIcon,
  moon: MoonIcon,
  notification: NotificationIcon,
  message: MessageIcon,
  user: UserIcon,
  contacts: ContactsIcon,
  logout: LogoutIcon,
  'info-circle': InfoCircleIcon,
  'info-square': InfoSquareIcon,
  box: BoxIcon,
  printer: PrinterIcon,
  test: TestIcon,
  illustration: IllustrationIcon,
  'dashboard-preview': DashboardPreviewIcon,
  'background-bubbles': BackgroundBubblesIcon,
  'dot-grid': DotGridIcon,
  'lock-filled': LockFilledIcon,
  dollar: DollarIcon,
  'chevron-up-mini': ChevronUpMiniIcon,
  'chevron-down-mini': ChevronDownMiniIcon,
  refresh: RefreshIcon,
  store: StoreIcon,
  gift: GiftIcon,
  tags: TagIcon,
  'credit-card': CreditCardIcon,
  wallet: WalletIcon,
  radio: RadioIcon,
  eye: EyeIcon,
  reprint: ReprintIcon,
  reverse: UndoIcon,
  reject: RejectIcon,
  check: CheckIcon,
  globe: GlobeIcon,
  pay: PayIcon,
  history: HistoryIcon,
  'refresh-cw': RefreshIcon,
  file: FileIcon,
  'collapse-sidebar': CollapseSidebarIcon,
  'expand-sidebar': ExpandSidebarIcon,
  'panel-left-close': PanelLeftCloseIcon,
  'panel-left-open': PanelLeftOpenIcon,
  process: ProcessIcon,
  restaurant: RestaurantIcon,
  'meeting_room': MeetingRoomIcon,
  'table_restaurant': TableRestaurantIcon,
  'event_seat': EventSeatIcon,
  'receipt_long': ReceiptLongIcon,
  'soup_kitchen': SoupKitchenIcon,
  'restaurant_menu': RestaurantMenuIcon,
  'menu_book': MenuBookIcon,
  'precision_manufacturing': PrecisionManufacturingIcon,
  'inventory_2': Inventory2Icon,
  'shopping_cart': ShoppingCart2Icon,
  'warehouse': WarehouseIcon,
  'swap_horiz': SwapHorizIcon,
  'straighten': StraightenIcon,
  countertops: CountertopsIcon,
  assessment: AssessmentIcon,
  corporate_fare: CorporateFareIcon,
  point_of_sale: PointOfSaleIcon,
  business: BusinessIcon,
  payments: PaymentsIcon,
  'assignment_return': AssignmentReturnIcon,
  'delete_sweep': DeleteSweepIcon,
  // más íconos aquí...

  default: DefaultIcon,
};

export default iconMap;


export type IconName =
  | 'chevron-down'
  | 'success'
  | 'warning'
  | 'info'
  | 'error'
  | 'server-error'
  | 'dashboard'
  | 'authentication'
  | 'calendar'
  | 'chart'
  | 'forms'
  | 'inbox'
  | 'inventory'
  | 'invoice'
  | 'messages'
  | 'pages'
  | 'products'
  | 'profile'
  | 'purchase'
  | 'sale'
  | 'restaurant'
  | 'meeting_room'
  | 'table_restaurant'
  | 'event_seat'
  | 'delete_sweep'
  | 'soup_kitchen'
  | 'restaurant_menu'
  | 'menu_book'
  | 'precision_manufacturing'
  | 'inventory_2'
  | 'shopping_cart'
  | 'warehouse'
  | 'swap_horiz'
  | 'straighten'
  | 'countertops'
  | 'assessment'
  | 'settings'
  | 'tables'
  | 'task'
  | 'ui-elements'
  | 'user-management'
  | 'finance'
  | 'cash'
  | 'continue'
  | 'process'
  | 'cancel'
  | 'plus'
  | 'arrowleft'
  | 'return'
  | 'discount'
  | 'close'
  | 'addCircle'
  | 'serviceAdd'
  | 'save'
  | 'finalize'
  | 'finishFlag'
  | 'receiptCheck'
  | 'priceIncrease'
  | 'configuration'
  | 'settle-products'
  | 'document'
  | 'edit'
  | 'view'
  | 'report'
  | 'download'
  | 'upload'
  | 'hardware'
  | 'trash'
  | 'shoppingcart'
  | 'rotate-ccw'
  | 'package-check'
  | 'percent'
  | 'pdf'
  | 'search'
  | 'json'
  | 'invalidDte'
  | 'arrow-up-trend'
  | 'arrow-down-trend'
  | 'user-plus'
  | 'shopping-bag'
  | 'clock'
  | 'check-circle'
  | 'x-circle'
  | 'email'
  | 'print'
  | 'category'
  | 'catalog'
  | 'change'
  | 'home'
  | 'arrow-right'
  | 'lock'
  | 'brush'
  | 'sun'
  | 'moon'
  | 'notification'
  | 'message'
  | 'user'
  | 'contacts'
  | 'logout'
  | 'info-circle'
  | 'info-square'
  | 'box'
  | 'printer'
  | 'test'
  | 'illustration'
  | 'dashboard-preview'
  | 'background-bubbles'
  | 'dot-grid'
  | 'lock-filled'
  | 'dollar'
  | 'chevron-up-mini'
  | 'chevron-down-mini'
  | 'refresh'
  | 'refresh-cw'
  | 'store'
  | 'gift'
  | 'tags'
  | 'credit-card'
  | 'wallet'
  | 'radio'
  | 'eye'
  | 'reprint'
  | 'reverse'
  | 'reject'
  | 'check'
  | 'globe'
  | 'resend'
  | 'pay'
  | 'history'
  | "file"
  | 'collapse-sidebar'
  | 'expand-sidebar'
  | 'panel-left-close'
  | 'panel-left-open'
  | 'corporate_fare'
  | 'point_of_sale'
  | 'business'
  | 'payments'
  | 'receipt_long'
  | 'assignment_return'
  | 'default'; // fallback


